import * as React from 'react';
import { Props } from "../types";

export const ImageSlider = (props: Props.ImageSlider) => {
    const [current, setCurrent] = React.useState(props.imageIndex);
    const length = props.galleryImages.length;

    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1);
    };
    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1);
    };
    if (!Array.isArray(props.galleryImages) || props.galleryImages.length <= 0) {
        return null;
    }
    return (
        <React.Fragment>
            <div className={'c-modal__nav'}>
                <button aria-label="Previous" className='c-modal__slider__arrow c-modal__slider__arrow--left'
                        onClick={prevSlide}>Previous
                </button>
                <button aria-label="Next" className='c-modal__slider__arrow c-modal__slider__arrow--right'
                        onClick={nextSlide}>Next
                </button>
            </div>

            <section className='c-modal__slider'>
                {props.galleryImages.map((image, index) => {
                    return <div className={index === current ? 'c-modal__slider__slide c-modal__slider__slide--active' : 'c-modal__slider__slide'}
                                    aria-expanded={index === current ? 'true' : 'false'}
                                    key={`slider_image_${index}`}
                                >
                        <div className="c-modal__slide__text">
                            {image.caption !== '' && <h2 className="c-modal__text__caption">{image.caption}</h2>}
                            {image.credits !== '' && <h3 className="c-modal__text__credits">{image.credits}</h3>}
                        </div>
                                    <img src={image.imageUrl} width=""  alt="" className="" />
                           </div>
                })}
            </section>
        </React.Fragment>
    );
};
